// src/config/index.ts ----------------------------------------------------
import { paths } from 'src/routes/paths';

import packageJson from '../package.json';

export type ConfigValue = {
  appName: string;
  appVersion: string;
  serverUrl: string;
  assetsDir: string;

  auth: {
    method: 'amplify';
    skip: boolean;
    redirectPath: string;
  };

  amplify?: {
    config: {
      Auth: {
        Cognito: {
          region: string;
          userPoolId: string;
          userPoolClientId: string;

          loginWith: {
            oauth: {
              domain: string;
              scopes: string[];
              redirectSignIn: string[];
              redirectSignOut: string[];
              responseType: 'code' | 'token';
            };
          };
        };
      };
    };
  };
};

export const CONFIG: ConfigValue = {
  appName: 'Xpanse Portal',
  appVersion: packageJson.version,

  serverUrl: import.meta.env.VITE_SERVER_URL,
  assetsDir: import.meta.env.VITE_ASSETS_DIR ?? '',

  auth: {
    method: 'amplify',
    skip: false,
    redirectPath: paths.dashboard.root,
  },
};
